//列表的查询和清空功能
const searchTable = {
    methods:{
        search(obj) {
            this.searchWords = obj;
            this.$nextTick(() => {
                this.initList(1, this.page.page_size);
            })
            this.$refs.page.initCpage();
        },
        clear() {
            for (let i in this.searchWords) {
                this.searchWords[i] = "";
            }
            this.$nextTick(() => {
                this.initList(1, this.page.page_size);
            })
        },

    }
}
export default searchTable;
